// Vendor imports
const _ = require('lodash')
const React = require('react')

const NO_CLAMPING = -1

function useLineClampFitStyle({ disabled, domRef }) {
  // Cannot compute line clamping during server-side rendering
  if (typeof window === 'undefined') {
    return { } // No styles
  }
  const [ needsRecalculation, setNeedsRecalculation ] = React.useState(true)
  const [ lineCount, setLineCount ] = React.useState(NO_CLAMPING)
  React.useEffect(
    () => {
      const el = domRef.current
      if (!el || disabled || !needsRecalculation) {
        return
      }
      setLineCount(determineLineCount(el))
      setNeedsRecalculation(false)
    },
    [ domRef, disabled, needsRecalculation ]
  )
  React.useEffect(
    () => {
      if (disabled) {
        return
      }
      function onResize() {
        setLineCount(NO_CLAMPING)
        setNeedsRecalculation(true)
      }
      const debouncedResize = _.debounce(onResize, 500)
      window.addEventListener('resize', debouncedResize)
      return () => {
        window.removeEventListener('resize', debouncedResize)
        debouncedResize.cancel()
      }
    },
    [ disabled, setLineCount, setNeedsRecalculation ]
  )
  if (lineCount === NO_CLAMPING || isNaN(lineCount)) {
    return { } // No styles
  }
  if (lineCount === 0) {
    return { display: 'none' }
  }
  return { WebkitLineClamp: lineCount }
}

function determineLineCount(el) {
  const parentEl = el.parentElement
  const bottomY = el.offsetTop + el.offsetHeight
  // Check if the element is overflowing its parent
  if (bottomY <= parentEl.offsetHeight) {
    return NO_CLAMPING
  }
  // Count how many lines actually fit
  const computedStyle = window.getComputedStyle(el)
  const lineHeight = parseFloat(computedStyle.getPropertyValue('line-height'))
  const availableHeight = parentEl.offsetHeight - el.offsetTop
  return Math.floor(availableHeight / lineHeight)
}

module.exports = useLineClampFitStyle
